module.exports = require('gl-quat/slerp')


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/~/quat-slerp/index.js
 ** module id = 1117
 ** module chunks = 0
 **/